// extracted by mini-css-extract-plugin
export default {"coordinates-metrics":"coordinates-metrics_coordinates-metrics__0zL19","coordinates-metrics-popup":"coordinates-metrics_coordinates-metrics-popup__f4lRA"};